import { render, staticRenderFns } from "./returnVoucherStats.vue?vue&type=template&id=3054ddee&scoped=true&"
import script from "./returnVoucherStats.vue?vue&type=script&lang=js&"
export * from "./returnVoucherStats.vue?vue&type=script&lang=js&"
import style0 from "./returnVoucherStats.vue?vue&type=style&index=0&id=3054ddee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3054ddee",
  null
  
)

export default component.exports